import Rails from '@rails/ujs';

Object.assign(window, { Rails });

if (!window._rails_loaded) {
  Rails.start();
}
